import React from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from "reactstrap";
import isEmpty from 'lodash/isEmpty';
import get from "lodash/get";

import {
    BOT_TYPE_AVITO,
    BOT_TYPE_EXPRESS,
    BOT_TYPE_FB,
    BOT_TYPE_IG,
    BOT_TYPE_OK,
    BOT_TYPE_RETAILCRM,
    BOT_TYPE_TG,
    BOT_TYPE_VIBER,
    BOT_TYPE_VK,
    BOT_TYPE_WA,
    BOT_TYPE_WABA,
    BOT_TYPE_WABA_CHATAPI,
    SHOP_SOURCE_HIGHTOUCH,
    SHOP_SOURCE_RETAIL_CRM_INSTAGRAM_RU,
    SHOP_SOURCE_RETAIL_CRM_WABA_RU,
} from '../../../constants';
import AppHeader from '../../../Layout/AppHeader';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import AppSidebar from '../../../Layout/AppSidebar';
import ConnectCardTelegram from './ConnectCards/Telegram';
import ConnectCardWhatsApp from './ConnectCards/WhatsApp';
import ConnectCardWABA from './ConnectCards/WABA';
import ConnectCardInstagram from './ConnectCards/Instagram';
import ConnectCardVK from './ConnectCards/VK';
import ConnectCardAvito from './ConnectCards/Avito';
import ConnectCardOK from './ConnectCards/OK';
import ConnectCardFacebook from './ConnectCards/Facebook';
import ConnectCardViber from './ConnectCards/Viber';
import ConnectCardExpress from './ConnectCards/Express';
import BotCardTelegram from './BotCards/Telegram';
import BotCardWhatsApp from './BotCards/WhatsApp';
import BotCardFB from './BotCards/Facebook';
import BotCardVK from './BotCards/VK';
import BotCardAvito from './BotCards/Avito';
import BotCardWABA from './BotCards/WABA';
import BotCardWABAChatApi from './BotCards/WABAChatApi';
import BotCardViber from './BotCards/Viber';
import BotCardOK from './BotCards/OK';
import BotCardExpress from './BotCards/Express';
import BotCardRetailCRM from './BotCards/RetailCRM';
import Statistic from './Statistic/index';
import {getQueryParams} from "../../../Components/utils";
import {useTranslation} from "react-i18next";
import BotCardInstagram from "./BotCards/Instagram";


const AnalyticsDashboard = (
    {
        activeShop,
        bots,
    }
) => {
    const {t, i18n} = useTranslation();
    const isDebug = getQueryParams().debug;
    const isHighTouch = get(activeShop, 'source') === SHOP_SOURCE_HIGHTOUCH;
    const isRetailCRM = (
        get(activeShop, 'source') === SHOP_SOURCE_RETAIL_CRM_WABA_RU
        || get(activeShop, 'source') === SHOP_SOURCE_RETAIL_CRM_INSTAGRAM_RU
    );

    return <>
        <AppHeader/>
        <div className="app-main">
            <AppSidebar/>
            <div className="app-main__outer">
                <div className="app-main__inner">
                    {
                        isHighTouch && <PageTitle
                            heading={activeShop.trade_name}
                            icon="pe-7s-rocket icon-gradient bg-mean-fruit"
                        />
                    }

                    {
                        !isEmpty(bots) && !isRetailCRM && <Statistic/>
                    }

                    {
                        !isEmpty(bots) && <Container>
                            <h4 className='my-4'>
                                {t('pages.main.main.title_channels', 'Channels')}
                            </h4>
                            <Row>
                                {bots.map(
                                    (bot) => {
                                        let card;
                                        switch (bot.bot_type) {
                                            case BOT_TYPE_TG:
                                                card = <BotCardTelegram bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_WA:
                                                card = <BotCardWhatsApp bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_FB:
                                                card = <BotCardFB bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_VK:
                                                card = <BotCardVK bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_AVITO:
                                                card = <BotCardAvito bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_WABA:
                                                card = <BotCardWABA bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_WABA_CHATAPI:
                                                card = <BotCardWABAChatApi bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_VIBER:
                                                card = <BotCardViber bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_OK:
                                                card = <BotCardOK bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_EXPRESS:
                                                card = <BotCardExpress bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_IG:
                                                card = <BotCardInstagram bot={bot} key={bot.id}/>;
                                                break;
                                            case BOT_TYPE_RETAILCRM:
                                                card = <BotCardRetailCRM bot={bot} key={bot.id}/>;
                                                break;
                                            default:
                                                throw `Wrong BotType: ${bot.bot_type}`;
                                        }

                                        return <Col xs="12" sm="6" xl="4" key={bot.id}>
                                            {card}
                                        </Col>
                                    }
                                )}
                            </Row>
                        </Container>
                    }


                    <Container>
                        <h4 className='my-4'>
                            {t('pages.main.main.title_new_channels', 'Add new channels')}
                        </h4>
                        <Row>
                            <Col xs="12" sm="6" xl="4">
                                <ConnectCardWABA/>
                            </Col>
                            <Col xs="12" sm="6" xl="4">
                                <ConnectCardWhatsApp/>
                            </Col>

                            {/*<Col xs="12" sm="6" xl="4">*/}
                            {/*    <ConnectCardFacebook/>*/}
                            {/*</Col>*/}
                            {/*<Col xs="12" sm="6" xl="4">*/}
                            {/*    <ConnectCardInstagram/>*/}
                            {/*</Col>*/}
                            {/*<Col xs="12" sm="6" xl="4">*/}
                            {/*    <ConnectCardTelegram/>*/}
                            {/*</Col>*/}
                            {
                                isDebug && <>
                                    <Col xs="12" sm="6" xl="4">
                                        <ConnectCardVK/>
                                    </Col>
                                    <Col xs="12" sm="6" xl="4">
                                        <ConnectCardViber/>
                                    </Col>
                                    <Col xs="12" sm="6" xl="4">
                                        <ConnectCardAvito/>
                                    </Col>
                                    <Col xs="12" sm="6" xl="4">
                                        <ConnectCardOK/>
                                    </Col>
                                    <Col xs="12" sm="6" xl="4">
                                        <ConnectCardExpress/>
                                    </Col>
                                </>
                            }
                        </Row>
                    </Container>

                </div>
            </div>
        </div>
    </>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    bots: state.Bots.bots,
    billingConfig: state.Billing.billingConfig,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsDashboard);
